module.exports = __webpack_public_path__ + "static/media/18_l_stena_0_0.2c138f5d.png";